<template>
  <b-container>
    <!--title-->
    <h1 class="title"><strong>فرم تقاضای کالا یا محصول</strong></h1>
    <!--form-->
    <form
      ref="form"
      @submit.stop.prevent="handleSubmit"
      class="taghaza"
      id="sendForm"
    >
      <b-row>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="نام کالا و محصول" label-for="dName">
            <b-form-input
              id="dName"
              v-model="dName"
              required
              type="text"
            ></b-form-input>
            <span class="invalid">{{ nameState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="واحد" label-for="unit">
            <b-form-input
              id="unit"
              v-model="unit"
              required
              type="text"
            ></b-form-input>
            <span class="invalid">{{ unitState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="تعداد مورد درخواست" label-for="count">
            <b-form-input
              id="count"
              v-model="count"
              required
              type="number"
              class="dir-ltr"
            ></b-form-input>
            <span class="invalid">{{ countState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6 data">
          <label for="">تاریخ و ساعت</label>
          <date-picker
            v-model="datetime"
            type="datetime"
            format="YYYY-MM-DD HH:mm"
            display-format="jYYYY-jMM-jDD HH:mm"
            :timezone="true"
          />
        </b-col>
        <!--********-->
        <b-col class="col-12">
          <label label-for="text">توضیحات</label>
          <b-form-textarea
            id="text"
            v-model="text"
            rows="1"
            max-rows="6"
          ></b-form-textarea>
        </b-col>
        <!--********-->
        <b-col xl="12">
          <h2 class="title clear-both"><strong>مشخصات تماس</strong></h2>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="استان" label-for="province">
            <b-form-input
              id="province"
              v-model="province"
              required
              type="text"
            ></b-form-input>
            <span class="invalid">{{ provinceState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="شهر" label-for="city">
            <b-form-input
              id="city"
              v-model="city"
              required
              type="text"
            ></b-form-input>
            <span class="invalid">{{ cityState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="شماره ثابت" label-for="phone">
            <b-form-input
              id="phone"
              v-model="phone"
              required
              type="number"
              class="dir-ltr"
            ></b-form-input>
            <span class="invalid">{{ phoneState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="موبایل" label-for="mobile">
            <b-form-input
              id="mobile"
              v-model="mobile"
              required
              type="number"
              class="dir-ltr"
            ></b-form-input>
            <span class="invalid">{{ mobileState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <b-form-group label="ایمیل" label-for="email">
            <b-form-input
              id="email"
              v-model="email"
              required
              type="email"
              class="dir-ltr"
            ></b-form-input>
            <span class="invalid">{{ emailState }}</span>
          </b-form-group>
        </b-col>
        <!--********-->
        <b-col class="col-6">
          <div v-if="!image">
            <div class="btnUpload">
              <input id="file" ref="file" type="file" @change="onFileChange" />
              <button>آپلود فایل</button>
            </div>
          </div>
          <div v-else class="removeUpload">
            <img :src="image" />
            <button @click="removeImage">پاک کردن</button>
          </div>
          <!-- <input id="file" ref="file" type="file"> -->
        </b-col>
        <!--********-->
        <b-col class="col-12">
          <div class="input-group">
            <div
              id="recaptcha-main"
              class="g-recaptcha"
              data-sitekey="6Ldw7HIUAAAAAAW38OQmB98i3X070zN91Hm5J8fz"
            ></div>
            <button type="button" class="send" @click="handleSubmit">
              ارسال تقاضا
            </button>
          </div>
          <span class="red">{{ rcatch }}</span>
        </b-col>
      </b-row>
    </form>
    <span class="red">{{ result }}</span>
    <div class="resultForm" :class="{ open: true ? open : flase }">
      <span class="true" v-if="resultForm == true"
        >درخواست شما ثبت شد<i
          data-v-27f46840=""
          class="mdi mdi-close"
          @click="closeResultForm"
        ></i
      ></span>
      <span class="false" v-else
        >درخواست شما ثبت نشد<i data-v-27f46840="" class="mdi mdi-close"></i
      ></span>
    </div>
  </b-container>
</template>
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import axios from "axios";

export default {
  data() {
    return {
      dName: "",
      unit: "",
      count: "",
      text: "",
      province: "",
      city: "",
      phone: "",
      mobile: "",
      email: "",
      datetime: "",
      file: "",
      image: "",
      /************/
      nameState: null,
      unitState: null,
      countState: null,
      textState: null,
      phoneState: null,
      mobileState: null,
      emailState: null,
      provinceState: null,
      cityState: null,
      result: "",
      resultForm: false,
      open: false,
      captchaCheck: false,
      rcatch: "",
      // images:{
      //   FileName:'',
      //   FileType:'',
      //   Value:''
      // }
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  methods: {
    myCallback() {
      var recaptchaInterval = setInterval(function () {
        if (document.getElementById("recaptcha-main")) {
          grecaptcha.render("recaptcha-main");
          clearInterval(recaptchaInterval);
        }
      }, 1000);
    },
    closeResultForm() {
      this.open = false;
    },
    /*upload*/
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      /****/
      this.file = this.$refs.file.files[0];
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.image = "";
    },
    /*start-states*/
    nameStates() {
      if (!this.dName) {
        return (this.nameState = "لطفا نام خود را وارد نمائید");
      } else {
        return (this.nameState = "");
      }
    },
    unitStates() {
      if (!this.unit) {
        return (this.unitState = "لطفا واحد خود را وارد نمائید");
      } else {
        return (this.unitState = "");
      }
    },
    countStates() {
      if (!this.count) {
        return (this.countState = "لطفا تعداد مورد درخواست خود را وارد نمائید");
      } else {
        return (this.countState = "");
      }
    },
    provinceStates() {
      if (!this.province) {
        return (this.provinceState = "لطفا نام استان خود را وارد نمائید");
      } else {
        return (this.provinceState = "");
      }
    },
    optionStates() {
      if (!this.city) {
        return (this.cityState = "لطفا نام استان خود را وارد نمائید");
      } else {
        return (this.cityState = "");
      }
    },
    mobileStates() {
      if (!this.mobile) {
        return (this.mobileState = "لطفا شماره موبایل خود را وارد نمائید");
      } else if (this.mobile.length < 11 || this.mobile.length > 12) {
        return (this.mobileState = "شماره موبایل باید 11 رقمی باشد");
      } else {
        return (this.mobileState = "");
      }
    },
    emailStates() {
      if (!this.email) {
        return (this.emailState = "لطفا ایمیل خود را وارد نمائید");
      } else if (!this.validEmail(this.email)) {
        return (this.emailState = "ایمیل نا معتبر میباشد");
      } else {
        return (this.emailState = "");
      }
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkRecaptcha() {
      var recaptcha = new FormData(document.getElementById("sendForm"));
      if (!recaptcha.get("g-recaptcha-response").length) {
        return (this.rcatch = "اعتبار سنجی انجام نشده");
      } else {
        return (this.rcatch = "");
      }
    },
    /* end-states */
    handleSubmit() {
      this.nameStates();
      this.unitStates();
      this.countStates();
      this.provinceStates();
      this.optionStates();
      this.emailStates();
      this.mobileStates();
      this.checkRecaptcha();

      var recaptcha = new FormData(document.getElementById("sendForm"));

      if (
        this.nameState != "" ||
        this.unitState != "" ||
        this.countState != "" ||
        this.emailState != "" ||
        this.mobileState != "" ||
        this.rcatch != ""
      ) {
        return;
      } else {
        const formData = {
          ProductName: this.dName,
          unit: this.unit,
          ProdcutCount: this.count,
          RegisterDate: this.datetime,
          ProductDesc: this.text,
          Province: this.province,
          city: this.city,
          Phone: this.phone,
          MobilePhone: this.mobile,
          Email: this.email,
          Image: {
            FileName: this.file.name,
            FileType: this.file.type,
            Value: this.image.substring(this.image.indexOf(",") + 1),
          },
        };
        axios
          .post("/Request/Register", formData, {
            headers: {
              "g-recaptcha-response": recaptcha.get("g-recaptcha-response"),
            },
          })
          .then((res) => {
            var rec = res.request.response;
            if (rec === "0") {
              this.result = "اعتبارسنجی انجام نشد";
            } else if (rec === "2" || rec === "3") {
              this.result = " خطایی در اعتبارسنجی رخ داده";
            } else {
              (this.resultForm = true), (this.open = true);
              this.result = "";
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  created() {
    this.myCallback();
  },
};
</script>
<style>
.red {
  color: red;
  font-weight: bold;
  font-size: 10pt;
}
.title {
  margin-bottom: 30px;
}
.taghaza {
  text-align: right;
  padding-bottom: 50px;
}
.clear-both {
  clear: both;
}
ul li {
  list-style: none;
}
select {
  width: 100%;
  border: 0;
  border-bottom: 2px solid #777777;
  border-radius: 15px;
}
.form-control {
  border: 0;
  border-bottom: 1px solid #777777;
  border-radius: 15px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
option {
  font-size: 12pt;
}
label {
  color: #424242;
  font-size: 15pt;
  font-weight: normal;
}
.col-6,
.col-12 {
  margin-bottom: 45px;
}
.form-control {
  padding-top: 0;
  height: 30px;
}
.form-control:focus {
  box-shadow: none;
  border-bottom-color: #6a1b9a;
}
.dir-ltr {
  direction: ltr;
}
.btnUpload {
  width: 100%;
  height: 40px;
  position: relative;
  margin-top: 25px;
}
.btnUpload input {
  width: 100%;
  height: 40px;
  opacity: 0;
  position: absolute;
  z-index: 1;
  top: 0;
}
.btnUpload button {
  width: 100%;
  height: 40px;
  background: #6a1b9a;
  color: #fff;
  font-size: 13pt;
  display: block;
  border-radius: 25px;
  border: 0;
}
.removeUpload img {
  width: 90px;
  height: 90px;
  display: inline-block;
  vertical-align: middle;
}
.removeUpload button {
  padding: 0 15px;
  height: 40px;
  background: #ff5200;
  color: #fff;
  font-size: 13pt;
  display: block;
  border-radius: 25px;
  border: 0;
  display: inline-block;
  vertical-align: middle;
  margin-right: 15px;
  min-width: 150px;
}
.send {
  clear: both;
  display: block;
  width: 200px;
  height: 55px;
  background: #4caf50;
  color: #fff;
  font-size: 15pt;
  margin: 11px 35px;
  border: 0;
  border-radius: 25px;
}
.vpd-input-group label {
  background: transparent !important;
  padding: 0;
  position: absolute;
  left: 45px;
  top: -15px;
}
.vpd-input-group svg {
  width: 30px !important;
  height: 30px !important;
}
.vpd-input-group svg path {
  fill: #777777 !important;
}
.vpd-input-group input {
  border: 0;
  border-bottom: 1px solid #777777;
  border-radius: 15px;
  height: 30px;
  padding: 0 12px 0;
  top: -7px;
  position: relative;
  background: transparent;
}
.vpd-header,
.vpd-day:not([disabled]).selected .vpd-day-effect,
.vpd-day-effect {
  background: #6a1b9a !important;
}
.vpd-actions button {
  color: #6a1b9a !important;
}
.invalid-feedback,
.invalid {
  color: #dc3545;
  font-size: 7pt !important;
}
.form-group {
  margin: 0;
}
.col-sm-6,
.col-sm-12 {
  margin-bottom: 45px;
}
.resultForm {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  right: 0;
  z-index: 10;
  display: none;
}
.resultForm.open {
  display: block;
}
.resultForm > span {
  position: fixed;
  z-index: 11;
  width: 200px;
  height: 40px;
  padding: 12px 0;
  background: #fff;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  font-size: 9pt !important;
  text-align: center;
  border-radius: 25px;
}
.resultForm > span i {
  position: absolute;
  right: 10px;
  color: #333;
  top: 7px;
  cursor: pointer;
  font-size: 14pt;
}
.resultForm .true {
  color: #3c763d;
  background-color: #dff0d8;
}
.resultForm .false {
  color: #a94442;
  background-color: #f2dede;
}
@media all and (max-width: 992px) {
  label {
    font-size: 13pt;
    margin: 0;
  }
  .col-6,
  .col-12 {
    margin-bottom: 25px;
  }
}
@media all and (max-width: 576px) {
  label {
    font-size: 8.5pt;
    margin-right: 5px;
    display: block;
  }
  .col-6,
  .col-12 {
    margin-bottom: 15px;
  }
  .form-control {
    border-radius: 8px;
    font-size: 8.5pt;
    padding: 0 5px;
    height: 20px;
  }
  .vpd-input-group svg {
    width: 15px !important;
    height: 15px !important;
  }
  .vpd-input-group input {
    border-radius: 8px;
    height: 20px;
    font-size: 8.5pt;
    padding: 0 5px;
  }
  .row {
    margin: 0 -5px;
  }
  .row > * {
    padding: 0 5px;
  }
  .vpd-input-group label {
    left: 20px;
    top: -16px;
  }
  .col-12.col {
    margin-bottom: 25px;
  }
  .title {
    margin-bottom: 15px;
  }
  .btnUpload {
    height: 30px;
    margin-top: 8px;
  }
  .btnUpload input {
    height: 30px;
  }
  .btnUpload button {
    height: 30px;
    font-size: 9pt;
  }
  .send {
    width: 150px;
    height: 35px;
    font-size: 10pt;
    margin: 20px auto;
  }
  .removeUpload img {
    width: 45px;
    height: auto;
  }
  .removeUpload button {
    padding: 0 10px;
    height: 30px;
    font-size: 9pt;
    margin-right: 10px;
    min-width: 100px;
  }
  span {
    font-size: inherit !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Form.vue